module.exports = __webpack_public_path__ + "media/images/metronic/social/tumblr-e77aae5ea5d7100727f13c1bc0404efd.png";